// extracted by mini-css-extract-plugin
export default {"right":"Right_right__7emY9","infoIcon":"Right_infoIcon__7mvW0"};